export default "__VITE_ASSET__927c1228__"